/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Input, Modal, notification, Row, Select } from 'antd';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { OnAddorUpdateShipmentType } from '../../redux/ShipmentDetails/saga';

const { Option } = Select;

const AddNewShipmentType = (props) => {
  const { showAddModel, setShowAddModel, editRecord, isEdit, setIsEdit, OnfetchData } = props;

  const [shipmentType, setShipmentType] = useState('');
  const [addLoading, setAddLoading] = useState(false);
  const [equipTypeForm] = Form.useForm();
  useEffect(() => {
    if (isEdit && editRecord) setShipmentType(editRecord.name);
  }, [isEdit]);

  /** Adding or Updating Equipment types */
  const handleOk = async () => {
    if (shipmentType == '') {
      notification.warning({
        message: 'Please enter shipment type to proceed!',
      });
      return;
    }

    let obj = {
      name: shipmentType,
    };
    if (isEdit) {
      obj = {
        id: editRecord.id,
        data: {
          name: shipmentType,
        },
      };
    }
    setAddLoading(true);
    const res = await OnAddorUpdateShipmentType(obj, isEdit);
    if (res) await OnfetchData();
    setAddLoading(false);

    setShipmentType('');
    setIsEdit(false);
    setShowAddModel(false);
  };

  /** Resetting values on Closing Modal */
  const handleCancel = () => {
    setShowAddModel(false);
    setShipmentType('');
    setIsEdit(false);
    //equipTypeForm.resetFields();
  };

  return (
    <div>
      <Modal
        className="pipeline-modal"
        title={isEdit ? 'Update Shipment Type' : 'Create New Shipment Type'}
        centered
        visible={showAddModel}
        footer={[
          <Button
            key="cancel"
            onClick={handleCancel}
          >
            {'Cancel'}
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleOk}
            loading={addLoading}
          >
            {isEdit ? 'Update' : 'Add'}
          </Button>,
        ]}
      >
        <Form
          form={equipTypeForm}
          name="basic"
          layout="vertical"
          autoComplete="off"
          getContainer={false}
        >
          <Row gutter={24}>
            <Col lg={24}>
              <Form.Item
                label="Shipment Type"
                name="equipmentType"
                required
              >
                <div>
                  <Input
                    placeholder={'Enter new shipment type'}
                    value={shipmentType}
                    onChange={(e) => setShipmentType(e.target.value)}
                    size="large"
                  />
                </div>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default AddNewShipmentType;
